import { PartTypes, QdeStatusTypes, AssetTypes, InvoiceTypes, OrmBatchStatusType } from '@/enums'

function formatPascalToDescription(value) {
  return value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
    .replace(/^./, function (str) {
      return str.toUpperCase()
    })
}

function truncate(str, maxLength) {
  if (!str) return ''
  if (!maxLength || !Number.isInteger(maxLength)) maxLength = 100
  if (str.length > maxLength) return str.substring(0, maxLength) + '...'
  return str
}

function formatBulletString(array) {
  return array.map((item) => `• ${item}`).join('\n')
}

function toTitleCase(str) {
  if (!str) return str
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

const formatABN = (value) => {
  const abn = value || ''
  return `${abn.slice(0, 2)} ${abn.slice(2, 5)} ${abn.slice(5, 8)} ${abn.slice(8, 11)}`
}

const stripSpaces = (value) => (value ? value.toString().replace(/\s/g, '') : value)

const formatPartType = (value) => {
  const index = Object.values(PartTypes).findIndex((item) => item.value === value)
  return Object.keys(PartTypes)[index]
}

const formatQdeStatus = (value) => {
  if (value && QdeStatusTypes.hasOwnProperty(value)) {
    return QdeStatusTypes[value]
  } else {
    return ''
  }
}

const formatAssetType = (value) => {
  if (value === AssetTypes.Insurer) {
    return 'I'
  } else if (value === AssetTypes.Customer) {
    return 'C'
  }
}

const formatPOItemType = (value) => {
  switch (value) {
    case 'PART':
      return 'Parts'
      break
    case 'MISC':
      return 'Misc'
      break
    case 'SUBL':
      return 'Sublet'
      break
    case 'OTHER':
      return 'Other Purchases'
      break
  }
}

const replaceBr = (value) => {
  return value.replace(/<br\s*\/?>/gm, '\n')
}

const formatInvoiceType = (type) => {
  const invoiceType = Object.keys(InvoiceTypes).find((key) => InvoiceTypes[key] === type)
  const invoiceTypeText = invoiceType.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1')
  return invoiceTypeText
}

const formatBatchStatus = (value) => {
  const index = Object.values(OrmBatchStatusType).indexOf(value)
  const status = Object.keys(OrmBatchStatusType)[index]
  return status
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
    .replace(/^./, function (str) {
      return str.toUpperCase()
    })
}

const formatOrmBatchStatus = (value) => {
  if (value.toLowerCase() === 'none') {
    return '-- Batch Status --'
  } else {
    return value
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
      .replace(/^./, function (str) {
        return str.toUpperCase()
      })
  }
}

const camelCaseToDescription = (value) => {
  return !value
    ? ''
    : value
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
        .replace(/^./, function (str) {
          return str.toUpperCase()
        })
}

const formatJobStage = (value) => {
  if (value.toLowerCase() === 'none') {
    return '-- Job Stage --'
  } else {
    return value
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
      .replace(/^./, function (str) {
        return str.toUpperCase()
      })
  }
}
const formatPartCondition = (value) => {
  return value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
    .replace(/^./, function (str) {
      return str.toUpperCase()
    })
}

export {
  formatPascalToDescription,
  formatBulletString,
  truncate,
  toTitleCase,
  formatABN,
  stripSpaces,
  formatPartType,
  formatQdeStatus,
  formatAssetType,
  formatPOItemType,
  replaceBr,
  formatInvoiceType,
  formatBatchStatus,
  formatOrmBatchStatus,
  camelCaseToDescription,
  formatJobStage,
  formatPartCondition
}
